import {
  CenteredLayout,
  Paper,
  Text,
  Field,
  Stack,
  Inline,
  SubmitButton,
} from "@digitalreality/ui";
import { useForm, Controller } from "react-hook-form";
import LanguageSwitch from "../Components/LanguageSwitch/LanguageSwitch";
import PasswordField from "../Components/Inputs/PasswordField";
import { login } from "../Services/AuthService";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import React from "react";
import { getUserData } from "../Services/DealerAdminService";
import { RestApiResponse } from "../Models/RestApiResponse";
import { User } from "../Models/User";
import { useAppState } from "../StateStore/Store";
import { loggedIn } from "../StateStore/UserAuth/UserAuthActions";
import { useLocation, useNavigate } from "react-router-dom";

const background = require("../Images/login_background.jpg");
const logo = require("../Images/leicaLogo.png");

type LoginData = {
  email: string;
  password: string;
};

export default function Login() {
  const { t } = useTranslation();
  const { dispatch } = useAppState();

  const [loginFailed, setLoginFailed] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onBlur",
  });

  const onSubmit = (data: LoginData) => {
    setLoginFailed(false);

    login(data.email, data.password).then((result) => {
      setLoginFailed(!result.success);
      if (result.success) {
        getUserData().then((response: RestApiResponse) => {
          let data = {} as User;
          if (response.success) {
            data = response.data;
          } else {
            console.log("can not get user data");
          }
          dispatch(loggedIn(data));
          navigate(from, { replace: true });
        });
      }
    });
  };

  return (
    <CenteredLayout
      gradientBackground
      topLeft={<img width="70" src={logo} alt=""></img>}
      topRight={<LanguageSwitch />}
      imagePath={background}
    >
      <Paper
        sx={{
          p: 40,
        }}
        variant="blurred"
      >
        <form id="login" onSubmit={handleSubmit(onSubmit)}>
          <Stack gap={5} width={300}>
            <Text>{t("Texts.Login")}</Text>
            
            <Controller
              name="email"
              control={control}
              rules={{
                required: t("Texts.ValidationRequired") as string,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: t("Texts.EmailInvalid"),
                },
              }}
              render={({ field: { ...field } }) => (
                <Field
                  {...field}
                  sx={{ width: "300px" }}
                  label={t("Texts.Email")}
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              )}
            />
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({ field: { ref, ...field } }) => (
                <PasswordField
                  {...field}
                  inputRef={ref}
                  sx={{ width: "300px" }}
                  label={t("Texts.Password")}
                  error={!!errors.password}
                  helperText={errors.password && t("Texts.ValidationRequired")}
                />
              )}
            />{" "}
            {loginFailed && <Text color="red">{t("Texts.LoginFailed")}</Text>}
            <Inline justifyContent="flex-end">
              <SubmitButton>{t("Texts.Login")}</SubmitButton>
            </Inline>
          </Stack>
        </form>
      </Paper>
    </CenteredLayout>
  );
}
